import React from "react";
import "./welcome.scss";
import { useNavigate } from "react-router-dom";
import {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
} from "../../assets";

// Demo images for Polaroid effect
const polaroidImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
];

function Welcome() {
  const navigate = useNavigate();

  return (
    <>
      <div className="welcome-container">
        <div className="polaroid-wall">
          {polaroidImages.map((image, index) => (
            <div
              key={index}
              className="polaroid"
              style={{
                top: `${Math.random() * 70}%`, // Random top position
                left: `${Math.random() * 80}%`, // Random left position
                transform: `rotate(${Math.random() * 30 - 15}deg)`, // Random rotation for variety
              }}
            >
              <img
                src={image}
                alt={`Polaroid ${index}`}
                className="polaroid-img"
              />
            </div>
          ))}
        </div>
        <div className="welcome-content">
          <h1 className="welcome-message">Hello, My KUCHUPUCHU!</h1>
          <p className="welcome-sub-message">
            I couldn’t bring you flowers the first time we met, but here’s
            something that will last forever. These blooms are for you, and
            they’ll never wither or fade. :) Also a recap of our fist meet so you remember what happened! Like a little recap.
          </p>
          <button
            className="welcome-button"
            onClick={() => navigate("/flower")}
          >
            Click me!
          </button>
        </div>
      </div>
    </>
  );
}

export default Welcome;
